import React from "react"
import { Input, Row } from "antd"
import MaterialModal from "app/components/normal/MaterialModal"
import closeIcon from "app/styles/images/sp/close.svg"
import MaterialForm from "app/components/normal/MaterialForm/MaterialForm"
import MaterialFormItem from "app/components/normal/MaterialFormItem/MaterialFormItem"
import "./remarkModal.scss"

export default class extends React.Component {
  constructor(props){
  	super(props)
  	this.state = {
      remark: props.data.remark
    }
  }

  onInputChange = (e, field) => {
    this.setState({
      [field]: e.target.value
    })
  }

  render() {
    const { visible, action, onCancel, data } = this.props
    const { remark } = this.state
    return (
      <MaterialModal
        width={550}
        className="pgd-report-remarks-modal" title="报告备注"
        visible={visible}
        footer={(
          <Row
            type="flex"
            justify="center"
            align="middle"
            onClick={() => action(remark)}
          >
            <button className="save-remarks-btn">保存</button>
          </Row>
        )}
      >
        <img
          className="pgx-modal-close"
          src={closeIcon}
          alt="关闭对话框"
          onClick={() => onCancel("remarksModalShowed")}
        />
        <MaterialForm>
          <MaterialFormItem
            labelText="任务ID"
            labelWidth={48}
          >
            <div style={{ width: 389 }}>{data.id}</div>
          </MaterialFormItem>
          <MaterialFormItem
            className="remarks-formitem"
            labelText="报告备注"
            labelWidth={48}
          >
            <Input
              className="remarks-input"
              type="textarea"
              value={remark}
              onChange={(e) => this.setState({remark: e.target.value})}
            />
          </MaterialFormItem>
        </MaterialForm>
      </MaterialModal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/normal/RemarkModal/index.js